import { combineReducers } from 'redux';
import { get } from 'lodash';

import commonReducer, { CommonStoreKey } from './commonStore/reducer';
import callAPIReducer, { callAPIStoreKey } from './callAPI/reducer';
import layoutReducer, { LayoutStoreKey } from './layouts/reducer';
import pagination, { PaginationKey } from './paginationStore/reducer';
import { LogoutAPI } from '../helpers/APIs/CommonAPIs';

const combinedReducer = combineReducers({
    [callAPIStoreKey]: callAPIReducer,
    [LayoutStoreKey]: layoutReducer,
    [CommonStoreKey]: commonReducer
    // [PaginationKey]: pagination
});

export const reducers = (state, action) => {
    if (action.type === 'APIData/removeStoreData') {
        if (action.payload && state.CommonStore.impersonateUser !== null) {
            state = { CommonStore: { impersonateUser: { ...state.CommonStore.impersonateUser } } };
        } else {
            state = undefined;
        }
    }
    return combinedReducer(state, action);
};

export default combinedReducer;
